<template>
    <SoliAvatarBtn
        v-if="date && time && repeating !== null"
        @click="$emit('input', date)"
        :title="globalMomentLocalLongDate(new Date(`${date} ${time}`))"
        icon="today"
        :subtitleBottom="time"
        :subtitleBottom2="repeating"
        blue
    >
    </SoliAvatarBtn>
</template>

<script>
import globalMoment from "../../Mixins/GlobalMoment.js";

export default {
    mixins: [globalMoment],
    props: {
        date: {
            type: String,
            default: "",
        },
        time: {
            type: String,
            default: "",
        },
        repeating: {
            type: String,
            default: "Does Not Repeat",
        },
    },
};
</script>

<style></style>
